module.exports = __webpack_public_path__ + "img/incoming-green.b804eeef.svg";